module.exports = __webpack_public_path__ + "static/media/hall-P2.f64c7ea3.svg";